import React, { useState } from "react";
import { useContext } from "react";
import { RestaurantContext } from "../../Context/RestaurantData";
import { listItems } from "../DrawerUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
  Dashboard as DashboardIcon,
  People,
  Settings as SettingsIcon,
  GroupWork,
  // ReceiptRounded,
  RedeemRounded as CouponIcon,
  Timeline as CouponAnalyticsIcon,
  ImportExport as BulkExportOrders,
} from "@material-ui/icons";
import { Route, Redirect } from "react-router-dom/cjs/react-router-dom.min";
const UserAuth = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const [listItem, setListItem] = useState([...listItems]);
  const currentPath = location.pathname;
  const { restaurantData } = useContext(RestaurantContext);
  React.useEffect(() => {
    console.log("currentPath", currentPath);

    if (
      localStorage.getItem("COgnitoRole") === "RestAdmin" ||
      localStorage.getItem("COgnitoRole") === "Admin"
    ) {
    } else if (localStorage.getItem("COgnitoRole")) {
      const permissions =
        restaurantData?.groups?.[localStorage.getItem("COgnitoRole")]
          ?.permissions || {};
      const noAccessKeys = Object.keys(permissions).filter(
        (key) => permissions[key] === "NO_ACCESS"
      );
      let permissionList = listItem;
      for (let i = permissionList.length - 1; i >= 0; i--) {
        if (noAccessKeys.includes(permissionList[i].detect)) {
          permissionList.splice(i, 1);
        }
      }
      setListItem(permissionList);
    }
  }, [currentPath]);

  return (
    <>
      {localStorage.getItem("COgnitoRole") === "RestAdmin" ||
      localStorage.getItem("COgnitoRole") === "Admin" ? (
        <Route {...rest} render={(props) => <Component {...props} />} />
      ) : (
        <Route
          {...rest}
          render={(props) =>
            listItem.filter((path) => path.pageURL === currentPath).length >=
              1 || currentPath.includes("order-details") ? (
              <Component {...props} />
            ) : listItem[0].pageURL ? (
              <Redirect to={listItem[0].pageURL} />
            ) : (
              <>Your Not Authorized </>
            )
          }
        />
      )}
    </>
  );
};
export default UserAuth;
